import { ref, onMounted } from 'vue';
import axios from 'axios';

const base_url = import.meta.env.VITE_API_URL;

export function useDepartments() {
  const options = ref([]);

  const getFaculty = async () => {
    try {
      const response = await axios.get(`${base_url}/department`);
      const departments = response.data.filter((obj) => obj.NAME.startsWith('คณะ'));
      departments.unshift({ ID: 0, NAME: '-- กรุณาเลือก --' });
      options.value = departments;
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  onMounted(getFaculty);

  return {
    options,
  };
}
